import { render } from "./CategoryChildrenGridComponent.vue?vue&type=template&id=0b9198eb"
import script from "./CategoryChildrenGridComponent.vue?vue&type=script&lang=js"
export * from "./CategoryChildrenGridComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/category/CategoryChildrenGridComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b9198eb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b9198eb', __exports__)) {
    api.reload('0b9198eb', __exports__)
  }
  
  module.hot.accept("./CategoryChildrenGridComponent.vue?vue&type=template&id=0b9198eb", () => {
    api.rerender('0b9198eb', render)
  })

}


export default __exports__